import * as React from 'react';
import {CSSProperties} from 'react';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';

type BtnProps = {
    fontSize?: string;
    text: string;
    onClick?: () => void;
    lineHeight?: string;
    margin?:string;
    backgroundColor?:string;
    color?:string;
    top?: string;
    left?: string;
    fontFamily?:string;
    width?:string;
    border?:string;
    display?:string;
    justifyContent?:string;
    alignItems?:string;
    height?:string;
}



class _CampusButton extends React.Component<BtnProps, any> {

    buttonStyle : CSSProperties  = {
        width: '175px',
        height:'40px',
        fontSize: '10px',
        textTransform: 'uppercase',
        letterSpacing: '0.2em',
        textAlign: 'center',
        padding: '5px 10px',
        cursor: 'pointer',
        lineHeight:'1.4em',
        color:'#616060',
        margin:'auto',
        border:'1px solid black',
        fontFamily:'Reitam',
        ':hover': {
            backgroundColor:'rgb(97, 96, 96)',
            color:'white'
        },
        justifyContent:'center'
    }


    componentWillMount(){
        this.buttonStyle.fontSize = this.props.fontSize;
        this.buttonStyle.lineHeight = this.props.lineHeight;
        this.buttonStyle.margin = this.props.margin;
        this.buttonStyle.backgroundColor = this.props.backgroundColor;
        this.buttonStyle.color = this.props.color;
        this.buttonStyle.top = this.props.top;
        this.buttonStyle.left = this.props.left;
        this.buttonStyle.fontFamily = this.props.fontFamily;
        this.buttonStyle.width = this.props.width;
        this.buttonStyle.border = this.props.border;
        this.buttonStyle.display = this.props.display;
        this.buttonStyle.alignItems = this.props.alignItems;
        this.buttonStyle.height = this.props.height;



        if(this.props.fontSize)
            this.buttonStyle.fontSize = this.props.fontSize;
        if(this.props.lineHeight)
            this.buttonStyle.lineHeight = this.props.lineHeight;
        if(this.props.margin)
            this.buttonStyle.margin = this.props.margin;
        if(this.props.backgroundColor)
            this.buttonStyle.backgroundColor = this.props.backgroundColor;
        if(this.props.color)
            this.buttonStyle.color = this.props.color;
        if(this.props.fontFamily)
            this.buttonStyle.fontFamily = this.props.fontFamily;
        if(this.props.width)
            this.buttonStyle.width = this.props.width;
        if(this.props.border){
            this.buttonStyle.border = this.props.border;
        }
        if(this.props.display){
            this.buttonStyle.display = this.props.display;
        }
        if(this.props.alignItems){
            this.buttonStyle.alignItems = this.props.alignItems;
        }
        if(this.props.height)
            this.buttonStyle.height = this.props.height;
    }

    render() {
        return (
            <div onClick={this.props.onClick ? this.props.onClick.bind(this) : () => {}} style={this.buttonStyle}>
                <div>{this.props.text}</div>
            </div>
        )
    }
}
export var CampusButton = Radium(_CampusButton);
